export default __webpack_public_path__ + "static/media/controls_avg_maturity.2cc2b909.svg";